class i extends window.HTMLElement {
  constructor() {
    ;(super(), this.init())
  }
  init() {
    ;((this.buttons = this.querySelectorAll('[js-compare-button]')),
      (this.columns = this.querySelectorAll('[js-compare-column]')),
      (this.rows = this.querySelectorAll('[js-compare-rows]')),
      this.setupToggle())
  }
  setupToggle() {
    this.buttons.forEach(e => {
      e.addEventListener('click', () => {
        const t = e.dataset.side
        ;(this.buttons.forEach(s => s.classList.remove('active')),
          e.classList.add('active'),
          this.columns.forEach(s => {
            s.dataset.side === t
              ? s.classList.add('active')
              : s.classList.remove('active')
          }),
          this.rows.forEach(s => {
            s.dataset.side === t
              ? s.classList.add('active')
              : s.classList.remove('active')
          }))
      })
    })
  }
}
window.customElements.define('compare-table', i)
export { i as default }
